import EventHandler from './form/event-handler';

class Form {
    eventHandler;

    constructor() {
        this.selectors = {
            callName: '[data-modal]',
        };

        this.render();
    }

    static run() {
        return new Form();
    }

    setUpListeners() {
        this.eventHandler = new EventHandler({
            callName: this.selectors.callName,
        });

        document.addEventListener('click', this.eventHandler);
    }

    render() {
        this.setUpListeners();
    }
}

export default Form;
